import { render, staticRenderFns } from "./StatusSummaryBox.vue?vue&type=template&id=fc2c38f4&scoped=true&"
import script from "./StatusSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./StatusSummaryBox.vue?vue&type=script&lang=ts&"
import style0 from "./StatusSummaryBox.vue?vue&type=style&index=0&id=fc2c38f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2c38f4",
  null
  
)

export default component.exports